import React from 'react'
import { Link } from "react-router-dom";
import SliderHomeGallery from '../../component/slidercomponent/SliderHomeGallery';


const HomeGallery = () => {
    return (
        <>
            <div className="gallery-area py-120" style={{marginTop:"-100px"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 mx-auto">
                            <div className="site-heading text-center">
                                <span className="site-title-tagline"><i className="far fa-book-open-reader" /> Gallery</span>
                                <h2 className="site-title">Our <span>Gallery</span></h2>
                            </div>
                        </div>
                    </div>
                    <div className="row popup-gallery">
                        <SliderHomeGallery />
                    </div>
                </div>
            </div>



        </>
    )
}

export default HomeGallery